import React from "react";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import { DATE_FORMAT_FOR_DISPLAY } from "../../../constants/constants";
import moment from "moment";
import numeral from "numeral";

const DailyTotalImports = props => {
  const dailyTotals = useSelector(state => state.deadlinesDetail.dailyTotals);
  const dateCurrent = useSelector(state =>
    state.deadlinesDetail.subjective && state.deadlinesDetail.subjective.date
      ? state.deadlinesDetail.subjective.date
      : null);

  if (
    !dailyTotals ||
    (dailyTotals.toPay === 0 && dailyTotals.toCollect === 0)
  ) {
    return null;
  }

  const renderSingleImport = (
    id, label, amount, hasSibling
  ) => {
    if (amount === 0) return null;

    return (
      <div id={id} style={{ marginRight: hasSibling && "100px" }}>
        <div style={{ fontSize: "20px", lineHeight: "30px" }}>
          {numeral(amount).format("0,0.00")} €
        </div>
        <div style={{ lineHeight: "15px" }}>{label}</div>
      </div>
    );
  };

  return (
    <div
      style={{
        margin: "32px 0"
      }}
      className={"dbx-deadlines-dailyTotals"}
    >
      <div id="dailyTotals_Day" style={{ lineHeight: "15px" }}>
        <FormattedMessage id="deadlines.pages.detail.totalDeadlinesAt" />
        {moment(dateCurrent).format(DATE_FORMAT_FOR_DISPLAY)}
      </div>
      <div style={{ display: "flex", flexDirection: "row" }}>
        {renderSingleImport(
          "dailyTotals_toPay",
          <FormattedMessage id="deadlines.pay" />,
          dailyTotals.toPay,
          dailyTotals.toCollect !== 0
        )}
        {renderSingleImport(
          "dailyTotals_toCollect",
          <FormattedMessage id="deadlines.collect" />,
          dailyTotals.toCollect,
          false
        )}
      </div>
    </div>
  );
};
export default DailyTotalImports;
